import { FC, HTMLAttributes } from "react";
import { classes, style } from "typestyle";
import { dictionary } from "../../../state/common/constants/dictionary.constants";
import { useModalContext } from "../../../state/common/contexts/modal.context";
import { Button } from "../../elements/button.element";
import { InjectionService } from "../../../state/common/injection.service";

export interface IProps {
  attributes?: HTMLAttributes<HTMLDivElement>;
  appName: string;
  appStoreUrl: string;
  appIcon: string;
}

export const NewAppModal: FC<IProps> = (props) => {
  const { closeModal } = useModalContext();

  return (
    <div
      {...{
        ...props.attributes,
        className: classes(styles.container, props.attributes?.className),
      }}
    >
      <img src={props.appIcon} alt={props.appName} className={styles.appIcon} />
      <h2 className={styles.header}>
        {dictionary.texts.newAppAvailableTitle(props.appName)}
      </h2>
      <p className={styles.description}>
        {dictionary.texts.newAppAvailableDescription(props.appName)}
      </p>
      <p className={styles.note}>
        {dictionary.texts.newAppForClientsOnlyNote}
      </p>
      <Button
        flavour={"primary"}
        centerChildren
        attributes={{
          className: styles.downloadButton,
          onClick: () => InjectionService.openWebView(props.appStoreUrl),
        }}
      >
        <div className={styles.downloadButtonText}>
          {dictionary.literals.downloadTheNewApp}
        </div>
      </Button>
      <button type="button" className={styles.laterButton} onClick={closeModal}>
        {dictionary.literals.illDoItLater}
      </button>
    </div>
  );
};

const styles = {
  container: style({
    padding: "25px 20px 15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  }),
  appIcon: style({
    width: 96,
    height: 96,
    borderRadius: 22,
    boxShadow: "0px 10px 20px -5px #00000033",
    marginBottom: 20,
  }),
  header: style({
    color: "rgb(var(--rgb-color-primair-basis))",
    textAlign: "center",
    margin: "0 0 15px",
  }),
  description: style({
    fontSize: "1.06rem",
    margin: "0 0 25px",
    textAlign: "center",
  }),
  note: style({
    fontSize: "0.9rem",
    margin: "-10px 0 25px",
    padding: "10px 15px",
    borderRadius: 10,
    textAlign: "center",
    color: "rgb(var(--rgb-color-gray))",
    backgroundColor: "rgba(var(--rgb-color-gray), 0.1)",
  }),
  downloadButton: style({
    width: "100%",
    marginBottom: 10,
  }),
  downloadButtonText: style({
    fontSize: "1.05rem",
    fontWeight: "bold",
  }),
  laterButton: style({
    background: "none",
    border: "none",
    padding: 10,
    fontSize: "0.9rem",
    color: "rgb(var(--rgb-color-gray))",
    cursor: "pointer",
  }),
};
